import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';

const CounterContainer = GlobalStyle.BasicBlock.extend`
  display: flex;
  width: 131px;
  height: 46px;
  border: solid 1px ;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ error }) => error ? Colors.Red : '#9B9B9B'};
`

const ClickButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 24px;
  user-select: none;
  border-right: ${props => props.right? 'solid 1px #9B9B9B':''};
  border-left: ${props => props.left? 'solid 1px #9B9B9B':''};
`

const NumberInput = styled.input`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  width: 83px;
  color: ${Colors.MAIN_COLOR};
  border: none;
  padding: 6px;
  text-align: center;
`

export default class Counter extends PureComponent {
  render() {
    return (
      <CounterContainer error={this.props.error}>
        <ClickButton onClick={this.props.minus} right >-</ClickButton>
        <NumberInput
          min={this.props.min}
          max={this.props.max}
          value={this.props.number || ''}
          onChange={this.props.handleChange}
        />
        <ClickButton onClick={this.props.add} left >+</ClickButton>
      </CounterContainer>
    )
  }
}
